const memberSkillAssignments = {
  'Member Email': {
    requirementType: 'required',
    description:
      'Email of the member receiving the skills. Must exactly match an existing member in the workspace; rows with no match are skipped during import.',
    dataType: 'email',
    validator: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
  },
  Skills: {
    requirementType: 'required',
    description:
      'One skill, or a semicolon-delimited list (e.g. "Node;React"). Skills that do not yet exist in the workspace are created automatically. When appending, duplicate skills will be skipped.',
    dataType: 'string',
    validator: (value) => value.trim() !== '',
  },
  Action: {
    requirementType: 'optional',
    description:
      'Either "append" or "replace". "append" (the default when blank) adds the row\'s skills to the member\'s existing assignments; "replace" replaces them with exactly the skills in this row. Any other value skips the row. A member should appear in only one row when using "replace".',
    dataType: 'string',
    validator: (value) => ['', 'append', 'replace'].includes((value || '').trim().toLowerCase()),
  },
};

export default memberSkillAssignments;
